// extracted by mini-css-extract-plugin
export default {"workPanel":"index_workPanel__nRlnG"};